// src/stores/websocketStore.js

import { defineStore } from 'pinia'
import { initWebSocket, sendWebSocketMessage } from '@/utils/websocketService'
import { bindUidToWebSocket } from '@/api/game'

export const useWebSocketStore = defineStore('websocket', {
  state: () => ({
    messages: [],
    // isUserBound: false, // 添加标志位防止重复绑定
  }),
  actions: {
    init(url) {
      initWebSocket(url, (message) => {
        this.messages.push(message)
      })
    },
    sendMessage(message) {
      sendWebSocketMessage(message)
    },
    async bindUser(clientId) {
      // 检查是否已经绑定过用户
      // if (this.isUserBound) {
      //   console.log('User ID already bound to WebSocket connection:', clientId)
      //   return
      // }

      try {
        // 通过API接口绑定用户ID到WebSocket连接
        const uidMModal = {
          client_id: clientId,
        }
        const response = await bindUidToWebSocket(uidMModal)
        console.log('ws.js clientId  bound to WebSocket connection:', clientId, response)
        this.isUserBound = true // 设置标志位
        return response
      } catch (error) {
        console.error('ws.js Failed to bind user ID to WebSocket:', error)
        throw error
      }
    },
    // 添加重置绑定状态的方法
    resetBinding() {
      this.isUserBound = false
    },
  },
})
